import { AddressType } from '@api';

type GetAddressMultiLineStringReturnType = string | undefined;

export const getAddressMultiLineString = ({
  street,
  addition,
  zip,
  city,
  country,
}: AddressType): GetAddressMultiLineStringReturnType => {
  if (!street && !addition && !zip && !city && !country) return;

  return [
    [street, addition].filter(Boolean).join(' '),
    [zip, city, country].filter(Boolean).join(' '),
  ].join('\n');
};
